import MyGoogleMap from 'javascripts/modules/google-map';

class LocationMap {

	constructor(){
		this._init();
	}

	_init(){
		const args = {
			// streetViewControl: false,
			// panControl:        false,
			// scrollwheel:       false,
			// cluster:           false
		};
	  const map = new MyGoogleMap('contact-map', args);
	}

}

export const locationMap = new LocationMap();